module.exports = __webpack_public_path__ + "img/image--233.72bd7876.jpg";